<template>
  <search-group
  @search="findData"
  @clear="clearValue"
  :span="24"
  :inline="true"
  :btnOffset="21"
  >
    <Row class="mb16" :gutter="16">
      <Col span="5">
        <Select v-model="searchData.projectFid" placeholder="项目名称" >
          <Option value=''>请选择</Option>
          <Option v-for="(item,index) in projectList" :key="'s1'+index" :value="item.value">{{item.text}}</Option>
        </Select>
      </Col>
      <Col span="5">
        <Select v-model="searchData.estimationType" placeholder="类型" @on-change="getConditionList">
          <Option value=''>请选择</Option>
          <Option v-for="(item,index) in typeList" :key="'s2'+index" :value="item.value">{{item.text}}</Option>
        </Select>
      </Col>
      <Col span="5">
        <Select v-model="searchData.itemCode" placeholder="费用项" >
          <Option value=''>请选择</Option>
          <Option v-for="(item,index) in conditionList" :key="'s2'+index" :value="item.value">{{item.text}}</Option>
        </Select>
      </Col>
      <Col span="5">
        <DatePicker style="width:100%" v-model="searchData.createTime"  split-panels type="daterange" format="yyyy-MM-dd" placeholder="生效日期筛选"></DatePicker>
      </Col>
    </Row>
  </search-group>
</template>

<script>

// import SearchGroup from 'components/SearchGroup/index';
import { formatDateTime } from "../../../../utils/format";
import { condition } from "api/targetApi"
export default {
  components:{
    // SearchGroup
  },
  props:{
    projectList:{
      type:Array,
      default(){
        return []
      }
    },
    typeList:{
      type:Array,
      default(){
        return []
      }
    },
    budgetCodeList:{
      type:Array,
      default(){
        return []
      }
    }
  },
  data(){
    return{
      conditionList:[],
      searchData:{
        projectFid:'',
        estimationType:'',
        itemCode:'',
        createTime:['',''],
      }
    }
  },
  computed:{
    searchDataParams(){
      function f(data) {
        return data?formatDateTime(data, false):''
      }
      return {
        projectFid:this.searchData.projectFid,
        estimationType:this.searchData.estimationType,
        itemCode:this.searchData.itemCode,
        startDate: f(this.searchData.createTime[0]),
        endDate:f(this.searchData.createTime[1])
      }
    }
  },
  mounted(){
    this.$emit('searchParams',this.searchDataParams)
  },
  methods:{
    getConditionList(value){
      if(!value){
        this.conditionList = []
        return
      }
      condition({
        type:value
      })
      .then( res => {
        this.conditionList = res.data;
      })
    },
    findData(){
      this.$emit('searchParams',this.searchDataParams)
    },
    clearValue(){
      this.searchData = {
        projectFid:'',
        estimationType:'',
        itemCode:'',
        createTime:['',''],
      }
    },
  }
}
</script>

<style>

</style>
